/**
 * This module keeps track of the state for all creative/ route data
 * such as players.
 * All mutations are namespaced creative/.
 */
import firebaseService from '../../services/firebase';

const state = {
  players: [],
};

const mutations = {
  setPlayers(state, players) {
    state.players = players;
  },
};

const actions = {
  async fetchPlayers({ commit }, { filterKey, token }) {
    const players = await firebaseService.getPlayersByBrandFilter(
      String(filterKey).toLowerCase(),
      token,
    );
    const playerArray = Object.keys(players).reduce((all, id) => {
      const player = players[id];

      if (player.version === '2.0' || player.version === 3) {
        all.push(player);
      }

      return all;
    }, []);

    commit('setPlayers', playerArray);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
